import { shopInfo, areaName, hvnUriRoot,slideArr } from "./core/defines";
import { useState, useEffect } from "react"
import { parseHtmlAsSingleElement, getEntranceHtmlText } from "./service/getEntranceText"

const enterbanner = {
    
    pc: "/img/slides/20251030/slide-01-pc.webp",
    sp: "/img/slides/20251030/slide-01-sp.webp",
    /*
    pc: "https://api.marineblue-g.com/api/topbanner?t=m_marineblue",
    sp: "https://api.marineblue-g.com/api/topbanner?t=m_marineblue&sp=t",
    */

}
// console.log(enterbanner)

const hvnEnter = "https://www.cityheaven.net/ibaraki/A0801/A080101/mt-marin-blue/?of=y2"

const recruitLink={
    men: "https://mens-qzin.jp/ibaraki/area_08001/detail/marinebluemito/?v=official",
    women: "https://kitakanto.qzin.jp/mitomarineblue/?v=official",
}

const outsideLinks=`
<nav class="links">

    <div class="bnr"><a href="https://mensheaven.jp/17/mt-marin-blue/?of=y"><img src="https://img.cityheaven.net/img/kikaku/kikaku/wp-content/uploads/2023/05/ジョブ版はこちら.png" width="640px"></a></div>
    <div class="bnr"><a href="https://www.cityheaven.net/ibaraki/A0801/A080101/shop-list/biz4/" target="_blank"><img src="https://img.cityheaven.net/img/mutual_link/468_68_28.jpg" width="640px" border="0" alt="水戸のソープ｜シティヘブンネット"></a></div>

    <div class="bnr"><a href="https://mensheaven.jp/16/ibaraki/ma-165/shop-list/" target="_blank"><img src="https://img.mensheaven.jp/img/fppc/bnr/074.jpg" width="640px" border="0" alt="水戸のスタッフ求人｜ジョブヘブン"></a></div>

    <div class="bnr"><a rel="nofollow" href="https://www.cityheaven.net/ibaraki/A0801/A080101/mt-marin-blue/?of=y" alt="当店ヘブン版はこちら" target="_blank"><img src="https://img.cityheaven.net/img/kikaku/kikaku/wp-content/uploads/2023/05/ヘブン版はこちら.png" width="640px" alt="バニラ求人"></a></div>
    <div class="bnr"><a rel="nofollow" href="https://kitakanto.qzin.jp/mitomarineblue/?v=official" target="_blank"><img src="https://ad.qzin.jp/img/vanilla468-60.gif" width="640px" alt="バニラ求人"></a></div>
    <div class="bnr"><a rel="nofollow" href="https://ranking-deli.jp/fuzoku/style5/13/" target="_blank"><img src="https://ranking-deli.jp/assets/img/user/link/2018bnr01.jpg" alt="[駅ちか]で探す茨城のヘルス情報" width="640px"></a></div>
</nav>
`

function Entrance(){
        const [entranceText, setEntranceText]=useState(<></>)

    useEffect(()=>{
        const getText=async()=>{

            setEntranceText(parseHtmlAsSingleElement(await getEntranceHtmlText()))
        }

        getText()

    }, [])

    return(
        <article id="entrance" className="txt-center">
            <header>{ areaName }のソープランド 【{ shopInfo.name }】</header>
            <picture>
                <source media="(max-width: 720px)" srcSet={enterbanner.sp} />
                <source media="(min-width: 721px)" srcSet={enterbanner.pc} />
                <img src={enterbanner.pc} alt={ `${ areaName }のソープランド 【${ shopInfo.name }】` } />
            </picture>

            <div className="wrappar">
                <div className="attention-container">
                    <div className="attention-box">
                        当店は暴力団を含む反社会的団体<br/>
                        及びスカウト等との関わりは一切ございません。
                    </div>
                    <div class="attention-wrap">
                        {entranceText}
                    </div>
                </div>

                <p className="w-100 kin-txt">
                    <img src="/img/18txt.png" width="50" alt="当サイトはアダルトコンテンツを含みます。18歳未満の方のご利用は固く禁じられています。" />
                    当サイトはアダルトコンテンツを含みます。<br/>
                    18歳未満の方のご利用は固く禁じられています。
                </p>
                <a className="exit" href="https://www.yahoo.co.jp" nofollow>18歳未満の方は<u>コチラ</u>からご退出ください。</a>

                <nav className="enter">
                    <ul>
                        <li><a className="btn to-home" href="/home"><span>ENTER</span>18歳以上のお客様ページ</a></li>
                        <li><a className="btn to-hvn" href={ hvnEnter }>ヘブン版ページはコチラ</a></li>
                    </ul>
                </nav>

                <section className="recruit">
                    <ul className="box">
                        <li className="btn women"><a rel="nofollow" href={recruitLink.women} target="_blank"><p class="-main">女性求人はコチラ</p><p><span class="-sub">20歳以上の方のみ</span></p></a></li>
                        <li className="btn men"><a href={recruitLink.men}><p class="-main">男性求人はコチラ</p><p><span class="-sub">ENTER</span></p></a></li>
                    </ul>
                </section>

                {/* ヘブンバナー類 直書きのstyleの記述方が違うので注意。特にプロパティ名がlowCamelCaseの点に注意 */}
                <div class="enterbanner"
                    dangerouslySetInnerHTML={{
                        __html: outsideLinks
                    }}>
                </div>
            </div>
        </article>
    );
}

export default Entrance;